"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conflict = void 0;
const ApiException_1 = require("./ApiException");
class Conflict extends ApiException_1.ApiException {
    constructor(message = 'Conflict', data) {
        super(message, data);
    }
}
exports.Conflict = Conflict;
